export const sectionsTestIds = {
  lazyLoadedSection: 'lazy-loaded-section',
  section: (sectionId: string) => `section-${sectionId}`,
};
